import usePageTitle from "@/hooks/usePageTitle";
import TabLayout from "../_TabLayout";
import CoverageRoleTable from "../_components/CoverageRoleTable";
import { UPDATE_SECTION_RECRUITER_MUTATION } from "../mutations";

export default function RecruitersTabPage() {
  usePageTitle("/configuration/recruiters", "Member 360 Configuration | Recruiters");

  return (
    <TabLayout>
      <CoverageRoleTable
        kind="recruiter"
        personColumnHeader="Recruiter"
        consultantTabLabel="By Recruiter"
        searchPlaceholder="Search Sections"
        assignHeadline="Assign Recruiter"
        staffLabel="Recruiter"
        addPersonActionLabel="Add Recruiter"
        clearHeadline="Clear Recruiter"
        mutation={UPDATE_SECTION_RECRUITER_MUTATION}
        tableTestId="recruiters-table"
      />
    </TabLayout>
  );
}
